import {getNextId} from "../../../util/misc";
import {ISyncField} from "../../../index";

export abstract class FormAbstract {
    abstract readonly name: TFormPartName;

    id = 'form-view-part-' + getNextId();

    constructor(protected field: IField) {
    }

    abstract isValid(): boolean;

    abstract getHtml(): string;

    abstract getSubmitData(): ISyncField | null;

    abstract getSubmitDataButton(): ISyncField | null;

    abstract getFormPartParameters(): any;

    dispose(): void {
    }

}